import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type TClientProfileService = {
  payload: {
    idClient: string
  }
}

export const getCustomerProfileService = async ({
  payload,
}: TClientProfileService): Promise<ResponseAPI> => {
  const response = await api.get(`perfilcliente/${payload.idClient}`)

  return response.data
}
